import { Directive, ElementRef, inject } from '@angular/core';
import { NavController } from '@ionic/angular';

import { objectFromUrlParams } from 'src/app/@shared/utils';

@Directive({
  selector: '[handle-internal-links]',
  standalone: false,
})
export class HandleInternalLinksDirective {
  private element = inject(ElementRef);
  private navController = inject(NavController);

  public ngOnInit(): void {
    this.element.nativeElement.addEventListener('click', this.onElementClicked.bind(this));
  }

  private onElementClicked(ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();

    const elem = ev.target as HTMLElement;

    if (!elem) { return; }
    if (elem.tagName.toUpperCase() !== 'A') { return; }

    let url = elem.getAttribute('href');

    if (!url) { return; }

    // eslint-disable-next-line prefer-destructuring
    const urlParams = url.split('?')[1];

    // eslint-disable-next-line prefer-destructuring
    url = url.split('?')[0];

    let queryParams = {};

    if (urlParams) {
      queryParams = objectFromUrlParams(urlParams);
    }

    this.navController.navigateForward(url, {
      queryParams,
    }).catch();
  }
}
